module.exports = {
    data: {
        terminal: 'Smart Terminals',
        smartCar: 'AI Patrol Car',
        smartChip: 'Smart Modules'
    },
    // 智能测温仪
    thermometer: {
        title: "Smart Temperature \nMeasurement System",
        introduction: "Smart temperature measurement system can not only monitor the body \ntemperature remotely and send alarm for abnormal body temperature \nin real time but also support face recognition and identification check \nas an optional function.",
        message1: {
            title: "Real-time Dual \nCamera Monitor",
            message1: "Remote body temperature measurement and face recognition",
            message2: "Real-time audio alerts and videos and images recording",
        },
        message2: {
            title: "Identification Check",
            message1: "Verify the identity via face recognition algorithm",
        },
        message3: {
            title: "Cloud Service",
            message1: "Real-time data upload to the cloud",
            message2: "Central management and data monitoring from backend",
        },
        message4: {
            title: "Body Temperature Detection",
            message1: "Forehead temperature measurement\nand real-time display",
            message2: "Measurement available within the \nvisible range of the camera",
        }
    },
    // 智能门禁
    accessControl: {
        title: 'Smart Access Control',
        introduction: 'Powered by high-performance AI modules and with sleek design, smart \naccess control can recognize and identify faces quickly and accurately \nbased on self-developed “Local Intelligence” algorithm.',
        subtitle1: {
            title: 'Binocular Anti-spoofing \nFace Detection',
            intro1: 'Real-time face detection with smooth and \nnon-delay experience',
            intro2: 'Support multi faces recognition with broad view',
        },
        subtitle2: {
            title: 'Multi-scenario Recognition',
            intro1: 'Recognition under variety of illumination conditions ',
            intro2: 'Patented face tracking exposure algorithm'
        },
        subtitle3: {
            title: 'Smart Attendance Check',
            intro1: 'Automatically generate monthly attendance reports',
            intro2: 'Attendance check while unlocking door via face recognition',
        },
        subtitle4: {
            title: 'Offline and \nOnline Modes',
            intro1: 'Offline mode is capable of independent \nlocal learning and training',
            intro2: 'Online mode supports data encryption and \nsecured cloud data synchronization',
        },
    },
    //汽车辅助驾驶
    ADAS: {
        title: 'Advanced Driver Assistance \nSystems (ADAS)',
        introduction: 'Identify traffic signs, recognize targets, analyze driver \nbehavior and detect head posture to provide alerts in\nadvance for any road emergency via real-time analysis.',
        subtitle1: {
            title: 'Single-lens Mode and \nDual-lens Mode',
            intro1: 'Single-lens mode manages outward-facing camera to analyze \nroad conditions and provide driver with alerts for any potential \ncollision and road emergency',
            intro2: 'Dual-lens mode manages both cameras to analyze driver \nbehavior and road conditions for a safer driving experience',
        },
        subtitle2: {
            title: 'Delicate Design and Craft',
            intro1: 'Each part is meticulously designed and crafted',
            intro2: 'Smooth metallic-textured surface'
        },
        subtitle3: {
            title: 'Smart Detection and \nAnalysis System',
            intro1: 'Target detection and recognition',
            intro2: 'Driver’s visual angle analysis',
        },
    },
    //智能巡检车
    patrolCar: {
        title: 'AI Patrol Car',
        introduction: 'Powered by “Local Intelligence” video analysis technology and \nautonomous route planning capability, AI patrol car can navigate \nboth indoors and outdoors and send alarms for any hazardous \nsituations such as property intrusion and violence, etc.',
        subtitle1: {
            title: 'Autonomous Patrol and \nIntelligent Obstacle \nAvoiding System',
            titleEN: 'Autonomous Patrol and Intelligent \nObstacle Avoiding System',
            intro1: 'Autonomous patrol',
            intro2: 'Multi-sensor intelligent system to go around obstacles',
        },
        subtitle2: {
            title: '“Local Intelligence” Based \nVideo Analysis',
            intro1: 'Abnormal intrusion',
            intro2: 'Unattended packages, fire, and smoke, etc.',
        },
        subtitle3: {
            title: 'Autonomous Recharge',
            intro1: 'Intelligent battery volume monitoring system',
            intro2: 'Autonomously navigate back to the charging station for recharge',
        },
        subtitle4: {
            title: 'Multi-scenario Applications',
            intro1: 'Parks, factories, and squares',
            intro2: 'Indoor and outdoor scenes'
        },
    },
    // 智能模组
    locChip: {
        title: '“Learning-On-Chip” \nSmart Module',
        introduction: 'Mind PointEye has independently created and developed “Learning on\nchip (LOC)” smart module with ultra-low power and high performance \nthat offers high generalization and online learning capability based on \nthe integration of multiple algorithms.',
        subtitle1: {
            title: 'Local Intelligence \nOnline Learning  ',
            intro1: 'Real-time learning and inference analysis',
        },
        subtitle2: {
            title: 'High Performance',
            intro1: 'High performance SoC structure design',
            intro2: "Energy consumption optimization and \nenhanced battery performance"
        },
        subtitle3: {
            title: 'Multi-algorithm Fusion',
            intro1: 'Face detection and anti-spoofing detection',
            intro2: 'Abnormal behavior detection',
            intro3: "Multiple-modality sensor data analysis"
        },
        subtitle4: {
            title: 'Multi-scenario Applications',
            intro1: 'AIoT, smart security, and smart building',
            intro2: 'Smart park, smart hospital, and smart diagnosis',
        },
    },
    // 智能终端核心板
    TerminalCore: {
        title: 'Core Board of \nSmart Terminal',
        introduction: 'The high-performance miniature motherboard developed independently \nwith precise stacking and layout design can be used for multiple \nembedded AI products with lightweight design.',
        subtitle1: {
            title: 'Craftsmanship',
            intro1: 'Using 2-4-2 HDI stack-up design \nSleeker and more compact',
            intro2: "Advanced gold-plating process \nSafer and more reliable"
        },
        subtitle2: {
            title: 'High Efficiency',
            intro1: 'High-performance SOC \nLow-power consumption and high-efficiency operation',
            intro2: "High-performance power module solution"
        },
        subtitle3: {
            title: 'Efficient Rate',
            intro1: 'IModules integrated with Wi-Fi, 5G and Bluetooth \nSupport dual frequency and dual antenna',
            intro2: 'Better performance and higher speed'
        },
        subtitle4: {
            title: 'Multiple I/O Supports',
            intro1: 'Various I/O interfaces',
            intro2: 'Adapts easily to customized expansion boards',
        },
    },
}



// WEBPACK FOOTER //
// ./src/assets/utils/lang/en_products.js